export function getCookie(cName: string): string | null {
  if (typeof cName !== 'string' || cName.length === 0) {
    return null
  }

  const name = `${cName}=`
  const cookies = document?.cookie?.split(';') || []

  for (const cookie of cookies) {
    const trimmedCookie = cookie?.trim()

    if (trimmedCookie?.startsWith(name)) {
      return trimmedCookie?.substring(name?.length)
    }
  }

  return null
}
